import { IDI_PROJECT_SEARCH_START_LOADING, IDI_PROJECT_SEARCH_END_LOADING, IDI_PROJECT_SEARCH_LOADED, SET_IDI_PROJECT_FILTER } from "../constants/IdiProjectConstants";
import { IDI_PROJECT_START_LOADING, IDI_PROJECT_END_LOADING, IDI_PROJECT_LOADED } from "../constants/IdiProjectConstants";

import { getApiData, postApiJsonData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIdiProjectSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_PROJECT_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("IdiProject/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: IDI_PROJECT_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_PROJECT_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_PROJECT_SEARCH_END_LOADING });
        }
    };
}

export function downloadIdiProjectSearch(filters, documentName) {
    return async (dispatch) => {
            
        await dispatch({ type: IDI_PROJECT_SEARCH_START_LOADING });

        try {

            var data = await downloadFile("IdiProject/ExportToExcel", filters);
            
            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = documentName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: IDI_PROJECT_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_PROJECT_SEARCH_END_LOADING });
        }
    };
}

export function setIdiProjectFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_IDI_PROJECT_FILTER,
            payload: filter
        });
    };
}

export function loadIdiProject(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_PROJECT_START_LOADING });

        try {

            var data = await getApiData("IdiProject/GetIdiProjectFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: IDI_PROJECT_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
                else if(data.errorCode == "402") {
                    if(data.companyId && data.companyId > 0) {
                        navigate('/invalid-company/idi/' + data.companyId + "/" + data.moduleName + "/" + id);
                    }
                    else {
                        navigate('/invalid-company');
                        dispatch(commonActions.setErrorMessage(data.errorDesc));
                    }
                }
                else {
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
            }
            
			await dispatch({ type: IDI_PROJECT_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_PROJECT_END_LOADING });
        }
    };
}

export function saveIdiProject(fbo, status, message, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_PROJECT_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("IdiProject/SaveIdiProjectFBO", { status, message }, fbo);
            
            if(data.success) {
                if(isAdd) {
                    navigate('/idi-project-edit/' + data.responseEntities[0].idiProject.id);
                    dispatch(commonActions.setSuccessMessage("IDI Project Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: IDI_PROJECT_LOADED,
                        payload: data.responseEntities[0]
                    });
                    
                    dispatch(commonActions.setSuccessMessage("IDI Project Saved Successfully!"));
                }
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

			await dispatch({ type: IDI_PROJECT_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_PROJECT_END_LOADING });
        }
    };
}

export function assignIdiProject(idiProjectId, userId, assignMe, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_PROJECT_START_LOADING });

        try {

            var data = await postApiJsonData("IdiProject/AssignIdiProject", { idiProjectId, userId, assignMe }, null);
            
            if(data.success) {
                dispatch(loadIdiProject(idiProjectId, navigate));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
            await dispatch({ type: IDI_PROJECT_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_PROJECT_END_LOADING });
        }
    };
}

export async function addInspectionToIdiProject(idiProjectId, stateName, visitType) {
    var returnData = {
        success: false,
        errorMessage: "",
        data: [],
        successMessage: "Inspection Added Successfully!"
    };

    try {

        var data = await getApiData("IdiInspection/AddInspectionToIdiProject", { idiProjectId, stateName, visitType });

        if(data.success) {
            returnData.success = true;
            returnData.data = data.responseEntities;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}